<!--<app-spinner *ngIf="!message"></app-spinner>-->
@if (
  message &&
  (message.author === 'user' ||
  (message.author === 'assistant' && (message.paragraphs.length || 0) > 0))
  ) {
  <div
    class="controls"
    >
    @if (message.date && message.author === 'assistant') {
      <span class="date">{{
        message.date | date: 'MMM dd, yyyy - HH:mm'
      }}</span>
    }
    @if (message.author === 'user') {
      <span class="bot-name">{{ getBotName() }}</span>
    }
    <!-- Keywords display -->
    @if (message.keywords && message.keywords.length > 0) {
      <div class="keywords">
        @for (keyword of message.keywords; track keyword) {
          <span class="keyword-chip">{{ keyword }}</span>
        }
      </div>
    }
    @if (!hideControls) {
      <div class="actions">
        <app-star-button
          [canStar]="canStar"
          [isStarred]="!!conversation.favorite"
          [onToggle]="toggleMessageStar.bind(this)"
        ></app-star-button>
        @if (message.author !== 'user') {
          <app-custom-button
            [icon]="'file_copy'"
            [tooltip]="'Copy to clipboard'"
            (buttonClick)="copyMessage(message)"
          ></app-custom-button>
        }
        <app-custom-button
          [icon]="'download'"
          [tooltip]="'Export conversation'"
          (buttonClick)="openExportModal()"
        ></app-custom-button>
        @if (shouldShowOriginalSources(message)) {
          <app-show-original-resources
            [originalSources]="getOriginalSources(message)"
          ></app-show-original-resources>
        }
      </div>
    }
  </div>
}
